import { styled } from '@linaria/react';

const Container = styled.span<{ isStrike?: boolean }>`
	padding: 4px 10px;
	width: max-content;
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	text-decoration: ${({ isStrike }) => (isStrike ? 'line-through' : 'none')};
	background: radial-gradient(
			139% 103.4% at 90.51% 100%,
			#4a5beb 0%,
			#511771 100%
		),
		rgba(255, 255, 255, 0.1);
	border-radius: 57px;
	box-shadow: 0 0 12px 0 rgba(255, 255, 255, 0.3) inset;

	&:empty {
		display: none;
	}
`;

type Props = {
	children: React.ReactNode;
	className?: string;
	isStrike?: boolean;
};

export const DiscountLabel = ({ children, className, isStrike }: Props) => (
	<Container className={className} isStrike={isStrike}>
		{children}
	</Container>
);
